export default "__VITE_ASSET__CBhXrTSH__"